

const Preloader = () => (
    <div className="dc-preloader">
        <div className="dc-spinner">
            <div className="dc-bounce1"></div>
            <div className="dc-bounce2"></div>
            <div className="dc-bounce3"></div>
        </div>
    </div>
);

export default Preloader;
